// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3hbOv","options":"AnswerScale_options__KCigX","selected":"AnswerScale_selected__aol4v"};